// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-table[data-v-0d29a934] {\n  padding-left: 30px;\n  box-sizing: border-box;\n}\n.edit-table .text-red[data-v-0d29a934] {\n  color: #f56c6c !important;\n}\n", ""]);
// Exports
module.exports = exports;
